import { supabase } from '../supabaseClient';

/* Accès aux données « briques ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchBricks() {
  return supabase.from('briques').select('*').order('id');
}

export function upsertBrickFromEpic(b, phaseId) {
  return supabase.from('briques').upsert(
    {
      id: b.id,
      phase_id: phaseId,
      nom: b.nom,
      jours_vendus: b.joursVendus,
      echeance: '',
      jira_epic: b.jira_epic,
    },
    { onConflict: 'phase_id,jira_epic', ignoreDuplicates: true },
  );
}

export function updateBrick(dbB, modalData) {
  return supabase.from('briques').update(dbB).eq('id', modalData.briqueId);
}

export function insertBrick(dbB, modalData, newBId) {
  return supabase.from('briques').insert({ id: newBId, phase_id: modalData.phaseId, ...dbB });
}

export function deleteBrick(b) {
  return supabase.from('briques').delete().eq('id', b.id);
}

export function upsertBrickFromLocalData(b, ph) {
  return supabase.from('briques').upsert({
    id: b.id,
    phase_id: ph.id,
    nom: b.nom,
    jours_vendus: b.joursVendus || 0,
    echeance: b.echeance || '',
    jira_epic: b.jira_epic || '',
  });
}
